import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/')
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      })
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{ fontFamily: 'sans-serif', maxWidth: '600px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h2>🐳 Docker Stack Smoke Test Dashboard</h2>
      <hr />
      
      <div style={{ margin: '20px 0' }}>
        <strong>🌐 Nginx Proxy & React Frontend: </strong>
        <span style={{ color: 'green', fontWeight: 'bold' }}>● Operational</span>
      </div>

      <div style={{ margin: '20px 0' }}>
        <strong>🐍 Flask Backend Container: </strong>
        {loading && <span style={{ color: 'orange' }}>Checking...</span>}
        {error && <span style={{ color: 'red', fontWeight: 'bold' }}>● Offline ({error})</span>}
        {data && <span style={{ color: data.status === 'success' ? 'green' : 'red', fontWeight: 'bold' }}>● {data.backend}</span>}
      </div>

      <div style={{ margin: '20px 0' }}>
        <strong>🗄️ MySQL Database Container: </strong>
        {loading && <span style={{ color: 'orange' }}>Checking...</span>}
        {error && <span style={{ color: 'red', fontWeight: 'bold' }}>● Unreachable</span>}
        {data && (
          <span style={{ color: data.status === 'success' ? 'green' : 'red', fontWeight: 'bold' }}>
            ● {data.database}
          </span>
        )}
      </div>

      {data && (
        <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '4px', overflowX: 'auto' }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
